import {useQuery} from "@tanstack/react-query";
import client from "../server/Client";






// GET ALL BRANCHES
const branches = (pageNumber='1',pageSize='10') => client.get(`branch?pageNumber=${pageNumber}&pageSize=${pageSize}`);
export const useGetBranches = (pageNumber,pageSize) => useQuery(['branches'],()=> branches(pageNumber,pageSize), {select: data => data?.data?.result,refetchInterval:60_000})